import React from 'react'
import { iconMap } from '../../../assets/icons/clinicas/iconMap'
import {
	BackTitle,
	Bold,
	Card,
	CardLabel,
	Container,
	Grid,
	Subtitle,
	Title,
	WaitLabel
} from './styled'
import { isCurrentTimeInRange } from '../../../utils/isCurrentTimeInRange'
import theme from '../../../styled/theme'
import { ChevronLeft } from '../../../assets/icons'
import useIsMobile from '../../../hooks/useIsMobile'

const Clinic = ({ clinics, saveClinic, clear }) => {
	const isMobile = useIsMobile();

	return (
		<Container>
			{!isMobile && (
				<BackTitle onClick={() => clear()}>
					<ChevronLeft size={8} /> Volver
				</BackTitle>
			)}
			<Title>Ingresá a la fila de la guardia</Title>
			<Subtitle>¿En qué clínica querés atenderte?</Subtitle>
			<Grid>
				{clinics.map(({ clinica, espera, horaFin, horaInicio }) => {
					const clinicStartTime = horaInicio || clinica?.horaInicio
					const clinicEndTime = horaFin || clinica?.horaFin
					const IconComponent = iconMap[clinica.codigoEmpresa] || iconMap['default']
					const hasTimeRange = Boolean(clinicStartTime && clinicEndTime)
					const isDisabled = hasTimeRange
						? !isCurrentTimeInRange(clinicStartTime, clinicEndTime)
						: false
					const handleCardClick = () => {
						if (isDisabled) return

						saveClinic({
							id: clinica.id,
							name: clinica.nombre,
							waitTime: espera,
							horaInicio: clinicStartTime,
							horaFin: clinicEndTime
						})
					}
					return (
						<Card
							key={clinica.id}
							onClick={handleCardClick}
							disabled={isDisabled}
						>
							{IconComponent && (
								<IconComponent
									primaryColor={
										isDisabled ? theme.colors.greys.disabledGrey : theme.colors.brand.blueOmint
									}
									aria-label={clinica.nombre}
								/>
							)}
							<div style={{ textAlign: isMobile ? 'left' : 'center' }}>
								<CardLabel>{clinica.nombre}</CardLabel>
								<WaitLabel>
									Tiempo de espera aprox:
									<Bold>{` ${espera} min`}</Bold>
								</WaitLabel>
							</div>
						</Card>
					)
				})}
			</Grid>
		</Container>
	)
}

export default Clinic
